import { useEffect, useState } from "react";

export default function useAfterLCP(fallbackMs = 4000) {
  const [lcpDone, setLcpDone] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let observer: PerformanceObserver | null = null;

    try {
      observer = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        if (entries.length > 0) {
          setLcpDone(true);
          observer?.disconnect();
        }
      });

      observer.observe({
        type: "largest-contentful-paint",
        buffered: true,
      });
    } catch {
      // Fallback if browser doesn't support LCP
      setLcpDone(true);
    }

    // Safety net: LCP may never fire (empty/hidden page, tab backgrounded
    // before paint, etc.), so don't withhold the deferred scripts forever.
    const fallbackTimer = setTimeout(() => setLcpDone(true), fallbackMs);

    return () => {
      observer?.disconnect();
      clearTimeout(fallbackTimer);
    };
  }, [fallbackMs]);

  return lcpDone;
}
